export const Revision = 0;
export const BranchName = "Unknown";
export const BuildDate = "1970-01-01T00:00:00.0000000Z";
